import React from "react";
import { useLang } from "@/lib/i18n";
import SeoLandingPage from "@/components/SeoLandingPage";
import { digitaleAdminNL } from "@/data/seo-landing-pages";

const DigitaleWagenparkadministratie = () => {
  const { lang } = useLang();
  return <SeoLandingPage data={digitaleAdminNL} lang={lang} />;
};

export default DigitaleWagenparkadministratie;
